import {EnumType, JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {ValueDisplayable} from "../modules/ui/interface/value.displayable";

@JacksonType("NBS")
@JsonIdentityInfo()
export class NBS extends SonnerBaseEntity implements ValueDisplayable{

  id: number;

  codigo: string;

  nome: string;

  getDisplayValue(): string {
    return this.codigo + " - " + this.nome;
  }

}
